export const apartmentsGlobalSettings = {
  header: {
    title: "Paramètres globaux",
    sub: "S'applique à <strong>{count} appartement</strong> de votre compte. | S'applique à <strong>{count} appartements</strong> de votre compte.",
    globalChip: "GLOBAL",
  },
  sections: {
    activate: "Activer le moteur de réservation",
    payment: "Quand le client paie-t-il ?",
    hold: "Durée de blocage",
    request: "Mode demande",
    link: "Lien à partager",
  },
  motor: {
    activeTitle: "Moteur actif",
    inactiveTitle: "Moteur inactif",
    activeDesc: "Les clients peuvent réserver directement depuis votre lien.",
    inactiveDesc: "Les réservations directes sont désactivées pour tous vos appartements.",
    statusOn: "Actif",
    statusOff: "Inactif",
  },
  payment: {
    onArrival: {
      name: "Payer à l'arrivée",
      hint: "Réservez gratuitement, payez à votre arrivée.",
    },
    online: {
      name: "Payer en ligne",
      hint: "Payez au moment de la confirmation de la réservation.",
    },
  },
  common: {
    saving: "Enregistrement…",
    onlyOnlineBadge: "Paiement en ligne uniquement",
  },
  hold: {
    desc: "Le calendrier est bloqué pendant que le client finalise le paiement.<br>S'il ne paie pas dans le délai fixé, <strong>la disponibilité est libérée automatiquement</strong>.",
  },
  units: {
    min: "min",
    hour: "heure",
    hours: "heures",
  },
  request: {
    enabledTitle: "Demandes activées",
    autoTitle: "Confirmation automatique",
    enabledDesc: "Le client envoie une demande. Vous l'acceptez ou la refusez via WhatsApp.",
    autoDesc: "La réservation est confirmée automatiquement une fois le paiement effectué.",
    tagControl: "Vous contrôlez qui réserve",
    tagWhatsapp: "WhatsApp à chaque nouvelle demande",
  },
  link: {
    desc: "Le même lien pour tous vos appartements. Partagez-le dans votre bio, vos campagnes ou vos messages automatisés.",
    copyTitle: "Copier",
    viewVisitor: "Voir en tant que visiteur",
    shareWhatsapp: "Partager via WhatsApp",
  },
  callout: "Sélectionnez un appartement dans la barre latérale pour définir les <strong>tarifs</strong>, <strong>promotions</strong> et <strong>frais</strong> individuellement.",
  savebar: {
    unsaved: "Modifications de blocage et de mode demande non enregistrées",
    save: "Enregistrer les paramètres",
  },
  toasts: {
    paymentUpdated: "Mode de paiement mis à jour.",
    paymentError: "Impossible d'enregistrer le mode de paiement.",
    saved: "Paramètres enregistrés.",
    saveError: "Enregistrement impossible.",
    linkCopied: "Lien copié.",
    copyError: "Copie impossible.",
  },
  share: {
    whatsappText: "Bonjour 👋 Voici le lien pour réserver : {link}",
  },
};